import { createContext, useContext } from "react";

export const RadioPlayerContext = createContext(null);

export const useRadioPlayerContext = () => {
  const ctx = useContext(RadioPlayerContext);
  if (!ctx)
    throw new Error("useRadioPlayerContext must be used within RadioPlayerProvider");
  return ctx;
};
